
import React, { useState, useEffect } from "react";
import ZaminRythu from "./ZaminRythu";
const menuData = [
    {
  title: "హోమ్",
  link: "https://teluguone.com/",
  children: []
   },
  {
    title: "వార్తలు",
    link: "https://www.teluguone.com/news/",
    children: [
      {
        name: "తాజా వార్తలు",
        link: "https://www.teluguone.com/news/contents/latestnews-25.html"
      },
         {
        name: "రాజకీయం",
        link: "https://www.teluguone.com/news/contents/politics-39.html"
      },
       {
        name: "ఆంధ్రప్రదేశ్",
        link: "https://www.teluguone.com/news/contents/andhrapradesh-43.html"
      },
       {
        name: "తెలంగాణ",
        link: "https://www.teluguone.com/news/contents/telangana-24.html"
      },
        {
         name: "భారత్",
          link: "https://www.teluguone.com/news/contents/india-23.html",
        },
         {
         name: "ప్రపంచం",
          link: "https://www.teluguone.com/news/contents/world-58.html",
        },
         {
         name: "బిజినెస్",
          link: "https://www.teluguone.com/news/contents/business-54.html",
        },
         {
         name: "టెక్నాలజీ",
          link: "https://www.teluguone.com/news/contents/technology-33.html",
        },
      {
        name: "తెలుగువన్ ప్రత్యేకం",
        link: "https://teluguone.com/news/contents/teluguoneexclusive-55.html"
      },
      {
        name: "చరిత్ర",
        link: "https://teluguone.com/news/contents/history-57.html"
      },
      {
        name: "సంపాదకీయం",
        link: "https://teluguone.com/news/contents/analytical-45.html"
      },
   
    ]
  },
  {
    title: "సినిమా",
    link: "https://teluguone.com/tmdb/",
    children: [
      {
        name: "తాజా వార్తలు",
        link: "https://teluguone.com/tmdb/pages/contentlist-tl-1.html"
      },
      {
        name: "ప్రత్యేక కథనాలు",
        link: "https://teluguone.com/tmdb/pages/contentlist-reviews-tl-49.html"
      },
      {
        name: "బాలీవుడ్ వార్తలు",
        link: "https://teluguone.com/tmdb/pages/contentlist-tl-50.html"
      },
      {
        name: "టీవీ వార్తలు",
        link: "https://teluguone.com/tmdb/pages/contentlist-tl-51.html"
      },
      {
        name: "ప్రత్యేక సినీ వార్తలు",
        link: "https://teluguone.com/tmdb/pages/contentlist-tl-56.html"
      },
      {
        name: "రివ్యూలు",
        link: "https://teluguone.com/tmdb/pages/reviews-tl.html"
      },
      {
        name: "గాసిప్స్",
        link: "https://teluguone.com/tmdb/pages/contentlist-tl-7.html"
      },
      // {
      //   name: "బాక్సాఫీస్",
      //   link: ""
      // },
      // {
      //   name: "ఓటీటి",
      //   link: ""
      // },
      // {
      //   name: "సెలబ్రిటీ",
      //   link: ""
      // },
      // {
      //   name: "ట్రైలర్స్",
      //   link: ""
      // }
    ]
  },
  {
    title: "చూడండి",
    link: "https://www.teluguone.com/movies/",
    children: [
      {
        name: "తాజా",
        link: "https://teluguone.com/movies/amp/contents/latest.html"
      },
      {
        name: "యాక్షన్",
        link: "https://teluguone.com/movies/amp/contents/action.html"
      },
      {
        name: "క్లాసిక్స్",
        link: "https://teluguone.com/movies/amp/contents/classics.html"
      },
      {
        name: "హాస్యం",
        link: "https://teluguone.com/movies/amp/contents/comedy.html"
      },
      {
        name: "కుటుంబం",
        link: "https://teluguone.com/movies/amp/contents/family.html"
      },
      {
        name: "ప్రేమ",
        link: "https://teluguone.com/movies/amp/contents/love.html"
      },
  
      // {
      //   name: "తాజా వీడియోలు",
      //   link: ""
      // },
      // {
      //   name: "ఇంటర్వ్యూలు",
      //   link: ""
      // },
      // {
      //   name: "షార్ట్స్",
      //   link: ""
      // },
      // {
      //   name: "వెబ్ సిరీస్",
      //   link: ""
      // },
      // {
      //   name: "లఘు చిత్రాలు",
      //   link: "https://www.teluguone.com/shortfilms/"
      // },
      // {
      //   name: "ప్రత్యక్ష ప్రసారం",
      //   link: ""
      // }
    ]
  },
  {
    title: "ఫోటోలు",
    link: "https://www.teluguone.com/photos/",
    children: [
      {
        name: "హీరోలు",
        link: "https://teluguone.com/photos/pages/actress-1.html"
      },
      {
        name: "హీరోయిన్లు",
        link: "https://teluguone.com/photos/pages/actors-2.html"
      },
      {
        name: "ఈవెంట్స్",
        link: "https://teluguone.com/photos/pages/events-10.html"
      },
      {
        name: "సినిమాలు",
        link: "https://teluguone.com/photos/pages/movies-8.html"
      },
      {
        name: "వాల్‌పేపర్లు",
        link: "https://teluguone.com/photos/pages/wallpapers-9.html"
      },
      // {
      //   name: "ప్రముఖ వ్యక్తి",
      //   link: ""
      // },
      // {
      //   name: "గ్యాలరి",
      //   link: ""
      // }
    ]
  },
  {
    title: "భక్తి",
    link: "https://www.teluguone.com/devotional/",
    children: [
      {
        name: "స్తోత్రాలు",
        link: "https://teluguone.com/devotional/contents/stotralu-943.html"
      },
      {
        name: "సహస్రనామాలు",
        link: "https://teluguone.com/devotional/contents/sahasranamalu-937.html"
      },
      {
        name: "మంగళహారతులు",
        link: "https://teluguone.com/devotional/videolist/mangalaharathulu-40.html"
      },
      {
        name: "వ్రతాలు",
        link: "https://teluguone.com/devotional/subpages/vratalu-113.html"
      },
      {
        name: "దేవతలు",
        link: "https://teluguone.com/devotional/contents/gods-47.html"
      },
      {
        name: "పండుగలు",
        link: "https://teluguone.com/devotional/contents/festivals-50.html"
      },
      {
        name: "దేవాలయాలు",
        link: "https://teluguone.com/devotional/subpages/punyakshetralu-65.html"
      },
      {
        name: "ఆడియో",
        link: "https://teluguone.com/devotional/contents/audio-49.html"
      },
      {
        name: "భక్తి వీడియోలు",
        link: "https://teluguone.com/devotional/videos/bhaktivideos.html"
      },
      {
        name: "ఆర్కైవ్స్",
        link: "https://teluguone.com/devotional/contents/library-48.html"
      },
      // {
      //   name: "పంచాంగం",
      //   link: ""
      // },
      // {
      //   name: "ఆధ్యాత్మిక వ్యాసాలు",
      //   link: ""
      // }
    ]
  },
  {
    title: "జీవనశైలి",
    link: "https://teluguone.com/news/contents/lifestyle-35.html",
    children: [
      {
        name: "ఆరోగ్యం",
        link: "https://teluguone.com/news/contents/health-34.html"
      },
       {
        name: "ఫ్యాషన్",
        link: "https://www.teluguone.com/vanitha/contents/fashion-71.html"
      },
      // {
      //   name: "మహిళలు",
      //   link: ""
      // },
      // {
      //   name: "విద్య",
      //   link: ""
      // },
      // {
      //   name: "ఉద్యోగాలు",
      //   link: ""
      // },
      // {
      //   name: "ప్రయాణం",
      //   link: ""
      // }
     
    ]
  },
  {
    title: "ఆహారం",
    link: "https://www.teluguone.com/recipes/amp/",
    children: [
      {
        name: "శాకాహారం",
        link: "https://teluguone.com/recipes/amp/contents/vegetarian-7.html"
      },
      {
        name: "మాంసాహారం",
        link: "https://teluguone.com/recipes/amp/contents/non-vegetarian-6.html"
      },
      {
        name: "స్వీట్లు & డెజర్ట్స్",
        link: "https://teluguone.com/recipes/amp/contents/sweetsndeserts-8.html"
      },
      {
        name: "అన్నం వంటకాలు",
        link: "https://teluguone.com/recipes/amp/contents/rices-4.html"
      },
      {
        name: "పచ్చళ్లు",
        link: "https://teluguone.com/recipes/amp/contents/pickles-9.html"
      },
      {
        name: "స్టార్టర్స్",
        link: "https://teluguone.com/recipes/amp/contents/appetizers-1.html"
      },
      // {
      //   name: "వంటకాలు",
      //   link: "https://www.teluguone.com/recipes/"
      // },
      // {
      //   name: "వంట వీడియోలు",
      //   link: ""
      // },
      // {
      //   name: "ఆరోగ్యకరమైన ఆహారం",
      //   link: ""
      // }
    ]
  },
  {
    title: "వినోదం",
    link: "",
    clickable: false,
    children: [
      {
        name: "హాస్యం",
        link: "https://teluguone.com/comedy/"
      },
      // {
      //   name: "మీమ్స్",
      //   link: ""
      // },
      // {
      //   name: "వైరల్",
      //   link: ""
      // },
      // {
      //   name: "వినోదం",
      //   link: ""
      // }
    ]
  },
  {
  title: "క్రీడలు",
  link: "https://teluguone.com/news/contents/sports-53.html",
  children: []
   },
   {
        title: "గ్రంథాలయం",
        link: "https://www.teluguone.com/grandalayam/",
         children: [
      {
        name: "నవలలు",
        link: "https://teluguone.com/grandalayam/books/novels.html"
      },
      {
        name: "రచయితలు",
        link: "https://teluguone.com/grandalayam/sub/writers.html"
      },
      {
        name: "ప్రచురణలు",
        link: "https://teluguone.com/grandalayam/writers/publications-1070.html"
      },
      {
        name: "చరిత్ర",
        link: "https://teluguone.com/grandalayam/writers/history-1727.html"
      },
    
    ]
  },
  {
    title: "మరిన్ని...",
    link: "",
    clickable: false,
    children: [
      {
        name: "తెలుగువన్ ఫౌండేషన్",
        link: "https://www.teluguonefoundation.in"
      },
      {
        name: "ఎన్ఆర్ఐ కార్నర్",
        link: "https://www.teluguone.com/nri/"
      },
      {
        name: "రేడియో",
        link: "https://www.teluguoneradio.com/"
      },
      {
        name: "వనిత",
        link: "https://teluguone.com/vanitha/"
      },
      {
        name: "కిడ్స్‌వన్",
        link: "http://www.kidsone.in/"
      },
      {
        name: "జ్యోతిష్యం",
        link: "https://teluguone.com/toneastrology/"
      },
      {
        name: "సాహిత్యం",
        link: "https://www.teluguone.com/sahityam/"
      }
    ]
  }
];

const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" fill="#074aad"><path d="M13.5 21v-8.02h2.69l.4-3.12h-3.09V7.9c0-.9.25-1.52 1.55-1.52h1.66V3.6c-.29-.04-1.27-.12-2.4-.12-2.38 0-4 1.45-4 4.11v2.27H7.6v3.12h2.71V21h3.19Z"/></svg>
);
const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#cc2366" strokeWidth="1.8">
    <rect x="3.5" y="3.5" width="17" height="17" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.2" cy="6.8" r="1" fill="#cc2366" stroke="none" />
  </svg>
);
const XIcon = () => (
  <svg viewBox="0 0 24 24" fill="#000000"><path d="M13.9 10.6 21.1 2h-1.7l-6.2 7.5L8.3 2H2.5l7.6 10.9L2.5 22h1.7l6.6-7.9 5.3 7.9h5.8l-7.9-11.4Zm-2.3 2.8-.8-1.1L4.7 3.3h2.6l4.9 7 .8 1.1 6.4 9.1h-2.6l-5.2-7.1Z"/></svg>
);

const YouTubeIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="#FF0000"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.6 3.5 12 3.5 12 3.5s-7.6 0-9.4.6A3 3 0 0 0 .5 6.2C0 8 0 12 0 12s0 4 .5 5.8a3 3 0 0 0 2.1 2.1c1.8.6 9.4.6 9.4.6s7.6 0 9.4-.6a3 3 0 0 0 2.1-2.1C24 16 24 12 24 12s0-4-.5-5.8ZM9.6 15.5v-7L16 12l-6.4 3.5Z" />
  </svg>
);

export default function Sidebar({ open, onClose }) {
  const [active, setActive] = useState(null);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const toggleMenu = (index) => {
    setActive(active === index ? null : index);
  };

  return (
    <>
     {open && (
  <div
    className="sidebar-overlay"
    onClick={onClose}
  />
)}

      <aside className={`touch-sidebar ${open ? "open" : ""}`}>
        <div className="touch-sidebar-header">
          
     <img
            src="https://teluguone.com/touchAMP/img/logo.webp"
            alt="TeluguOne"
          />

          <ZaminRythu />

          <button
            className="close-btn"
            onClick={onClose}
          >
            ×
          </button>
        </div>

        <ul className="touch-menu-list">
          {menuData.map((item, index) => (
            <li key={index}>
              {item.children.length > 0 ? (
                <>
                  <div className="menu-heading">
                   {item.title === "వినోదం" || item.title === "మరిన్ని..."  ? <span className="menu-heading">
    {item.title}
  </span>
   :               <a
                      href={item.link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {item.title}
                    </a>
                   }

                    <span
                      className="menu-toggle"
                      role="button"
                      tabIndex={0}
                      aria-expanded={active === index}
                      aria-label={`Toggle ${item.title} submenu`}
                      onClick={() => toggleMenu(index)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          toggleMenu(index);
                        }
                      }}
                    >
                      {active === index ? "▲" : "▼"}
                    </span>
                  </div>

                  <div
                    className={`submenu ${
                      active === index ? "open" : ""
                    }`}
                  >
                    {item.children.map((child, i) => (
                      <a
                        key={i}
                        href={child.link}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {child.name}
                      </a>
                    ))}
                  </div>
                </>
              ) : (
                <a
                  className="menu-heading single-link"
                  href={item.link}
                  target="_blank"
                  rel="noreferrer"
                >
                  <span>{item.title}</span>
                  <span className="menu-heading__spacer" aria-hidden="true" />
                </a>
              )}
            </li>
          ))}
           <h1 className="touch-menu-follow-head" >Follow Us On :</h1>
          <div className="touch-header__icons">
        <a className="touch-header__icon" href="https://www.facebook.com/profile.php?id=61587106207168" target="_blank" rel="noreferrer" aria-label="Facebook"><FacebookIcon /></a>
        <a className="touch-header__icon" href="https://www.instagram.com/teluguone/?hl=en" target="_blank" rel="noreferrer" aria-label="Instagram"><InstagramIcon /></a>
        <a className="touch-header__icon" href="https://x.com/Theteluguone?lang=en" target="_blank" rel="noreferrer" aria-label="X"><XIcon /></a>
        <a className="touch-header__icon" href="https://www.youtube.com/@teluguone" target="_blank" rel="noreferrer" aria-label="X"><YouTubeIcon /></a>
      </div>
       <div className="touch-header__icons">
           <a href="https://x.com/ToneNewsLive" target="_blank" className="header-social-tweets-anchor">● # Tweets</a>
        </div>
 
        </ul>
       
      </aside>

    </>
  );
}